<template>
  <section class="hero" aria-roledescription="carousel">
    <div
      class="hero-carousel"
      @touchstart.passive="onTouchStart"
      @touchend.passive="onTouchEnd"
    >
      <div class="hero-carousel__track" :style="{ transform: 'translateX(-' + slideIndex * 100 + '%)' }">
        <div
          v-for="(slide, idx) in slides"
          :key="'hero-slide-' + idx"
          class="hero-carousel__slide hero-carousel__slide--photo">
          <img
            class="hero-carousel__photo"
            :src="slide.image"
            :alt="slide.alt || '首页轮播'"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
  <!--    <div class="hero-carousel__dots" role="tablist" aria-label="轮播图页码">
        <button
          v-for="(_, i) in slides"
          :key="'hero-dot-' + i"
          type="button"
          class="hero-carousel__dot"
          :class="{ 'is-active': i === slideIndex }"
          role="tab"
          :aria-selected="i === slideIndex"
          :aria-label="'第' + (i + 1) + '屏'"
          @click="goSlide(i)"
        />
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroCarousel',
  props: {
    slides: { type: Array, default: () => [] },
    interval: { type: Number, default: 4500 }
  },
  data() {
    return { slideIndex: 0, timerId: null, touchStartX: 0 }
  },
  mounted() { this.start() },
  beforeDestroy() { this.clear() },
  methods: {
    goSlide(i) {
      const n = this.slides.length
      if (n === 0) return
      this.slideIndex = ((i % n) + n) % n
    },
    next() { this.goSlide(this.slideIndex + 1) },
    prev() { this.goSlide(this.slideIndex - 1) },
    start() {
      this.clear()
      if (this.slides.length <= 1) return
      this.timerId = window.setInterval(() => this.next(), this.interval)
    },
    clear() {
      if (this.timerId != null) { clearInterval(this.timerId); this.timerId = null }
    },
    onTouchStart(e) {
      if (!e.changedTouches || !e.changedTouches[0]) return
      this.touchStartX = e.changedTouches[0].clientX
    },
    onTouchEnd(e) {
      if (!e.changedTouches || !e.changedTouches[0]) return
      const dx = e.changedTouches[0].clientX - this.touchStartX
      if (dx < -48) this.next()
      else if (dx > 48) this.prev()
    }
  }
}
</script>

<style scoped>
.hero { padding: 0; overflow: hidden; border-radius: clamp(0.5rem, 2vw, 0.75rem); }
.hero-carousel { position: relative; touch-action: pan-y; }
.hero-carousel__track {
  display: flex; transition: transform 0.42s cubic-bezier(0.25, 0.8, 0.25, 1); will-change: transform;
}
.hero-carousel__slide { flex: 0 0 100%; min-width: 100%; box-sizing: border-box; }
.hero-carousel__slide--photo {
  padding: 0; position: relative; overflow: hidden; background: #e8eef5;
}
.hero-carousel__photo {
  display: block;
  width: 100%;
  height: auto;
}
.hero-carousel__dots {
  position: absolute; left: 0; right: 0; bottom: clamp(0.5rem, 2.5vw, 0.75rem); z-index: 2;
  display: flex; justify-content: center; align-items: center; gap: 0.375rem; pointer-events: none;
}
.hero-carousel__dots .hero-carousel__dot { pointer-events: auto; }
.hero-carousel__dot {
  width: 0.375rem; height: 0.375rem; padding: 0; border: none; border-radius: 50%;
  background: rgba(255,255,255,0.55); box-shadow: 0 1px 3px rgba(0,40,80,0.35); cursor: pointer;
  transition: width 0.2s ease, border-radius 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}
.hero-carousel__dot.is-active {
  width: 1rem; border-radius: 0.1875rem; background: #1e6bd6;
  box-shadow: 0 1px 4px rgba(30,107,214,0.45);
}
</style>
